import type { AdminCustomerCart, Scan } from "@hobbyshopify/backend-client";

/**
 * The customer's open cart's line for a scan: by the line's scan id, else by
 * card. A line from before offers carried a scan is sent with the offer id in
 * `scanId`, so that one is matched by card too.
 */
export function cartLineForScan(
  carts: readonly AdminCustomerCart[],
  scan: Pick<Scan, "id" | "cardId" | "customerId">,
): { cart: AdminCustomerCart; item: AdminCustomerCart["items"][number] } | null {
  for (const cart of carts) {
    if (cart.status !== "OPEN" || cart.user.id !== scan.customerId) continue;
    const item = cart.items.find((i) =>
      i.scanId && i.scanId !== i.offerId
        ? i.scanId === scan.id
        : scan.cardId !== null && i.offer.cardId === scan.cardId,
    );
    if (item) return { cart, item };
  }
  return null;
}

/** A confirmed scan whose quote still stands can be sold; one past its deadline cannot. */
export function canAddToCart(scan: Pick<Scan, "review" | "quoteState" | "recognitionOutcome">): boolean {
  return (
    scan.recognitionOutcome !== "no_match" &&
    scan.review === "CONFIRMED" &&
    (scan.quoteState === "active" || scan.quoteState === null)
  );
}

/** What the open cart charges for its included lines, before tax and fees. */
export function cartLinesTotalCents(cart: AdminCustomerCart): number {
  return cart.items
    .filter((i) => i.includedInPurchaseOrder)
    .reduce((sum, i) => sum + i.offer.priceCents * i.quantity, 0);
}
